<template>
  <router-link :to="'/projects/' + item.slug" @click.native="toggleModal">
    <div class="card card-row shadow-dark-lg featured-card">
      <div class="row no-gutters h-md-100">
        <div
          v-if="item.featured && item.featured != 0"
          class="col-12 col-md-6 bg-cover card-img-left h-100"
          :style="{
            backgroundImage: `url(${
              $store.state.api_url +
              '/images/organizations/' +
              item.id +
              '/thumbnail_' +
              item.featured.file_name
            })`,
          }"
        >
          <div
            class="shape shape-right shape-fluid-y svg-shim text-white d-none d-md-block"
          >
            <svg
              viewBox="0 0 112 690"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M116 0H51v172C76 384 0 517 0 517v173h116V0z"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
        </div>
        <div
          v-else
          class="col-12 col-md-6 d-flex align-items-center justify-content-center overlay-primary"
        >
          <div class="d-none d-md-block d-flex text-center">
            <div class="">
              <i
                v-if="item.category && item.category != 0"
                :class="'fad fa-' + item.category.icon"
                class="text-primary fa-3x"
              ></i>
              <i v-else class="fad fa-info text-primary fa-3x"></i>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card-body py-3">
            <h3>{{ item.name }}</h3>
            <p
              v-if="item.excerpt != 0"
              class="mb-0 text-muted description"
              v-html="item.excerpt"
            ></p>
          </div>
          <div class="card-meta">
            <hr class="card-meta-divider" />
            <h6
              class="text-uppercase text-muted mr-2 mb-0"
              v-if="item.category && item.category != 0"
            >
              <i :class="'fad fa-' + item.category.icon"></i>
              {{ item.category.name }}
            </h6>
            <h6 v-else class="text-uppercase text-muted mr-2 mb-0">
              <i class="fad fa-info"></i> General
            </h6>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  props: {
    item: {},
  },
  methods: {
    toggleModal() {
      if (this.$store.state.showDonate) {
        this.$store.state.showDonate = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
a:hover {
  text-decoration: none;
}
.icon-wrapper {
  width: 100%;
  background: #f1f1f1;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 120px;
}
.featured-card {
  height: 200px;
  width: calc(100%);
  .description {
    max-height: 65px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100%);
  }
}
@media (max-width: 420px) {
  .featured-card {
    height: 450px;
    .fa-3x,
    img {
      height: 150px;
    }
    .fa-3x {
      line-height: 150px;
    }
  }
}
</style>